import { inspectionCatalogV1ZhCN } from "./catalog/v1/zh-CN";

export const inspectionZhCN = {
  title: "巡检",
  loading: "加载中…",
  actions: {
    new: "新建巡检",
    openForm: "打开表单",
    delete: "删除",
    cancel: "取消",
    close: "关闭",
    back: "返回",
    next: "下一步",
    save: "保存",
    finalize: "定稿",
    add: "添加",
    filter: "应用筛选",
    clearFilters: "清除筛选",
    download: "下载",
    downloadReport: "下载",
  },
  kpi: {
    finalized: "已定稿",
  },
  conservationState: {
    title: "保养状态",
    caption: "保养状态（结构当前 — ANM 分类）",
    sum: "∑EC",
    empty: "保养状态尚未填写。",
    orient: "请勾选对应权重；任一列为 10 时，需进行特别巡检。",
    specialWarnBefore: "至少有一列选择了权重 10 — 请按 ANM 规范进行",
    specialWarnEmphasis: "特别巡检",
    specialWarnAfter: "。",
  },
  chart: {
    title: "跟踪",
    period: "期间",
    monthAbbrev: {
      jan: "1月",
      feb: "2月",
      mar: "3月",
      apr: "4月",
      may: "5月",
      jun: "6月",
      jul: "7月",
      aug: "8月",
      sep: "9月",
      oct: "10月",
      nov: "11月",
      dec: "12月",
    },
    periodMonths: {
      three: "最近 3 个月",
      six: "最近 6 个月",
      twelve: "最近 12 个月",
    },
    empty: "该期间无数据",
    series: {
      total: "总计",
      finalized: "已定稿",
      notFinalized: "未定稿",
      scheduled: "已计划",
      manual: "未计划",
    },
  },
  table: {
    filterButtonText: "筛选",
    empty: "该结构尚无巡检记录。",
    emptyFiltered: "未找到符合筛选条件的巡检记录。",
    fallback: "—",
    columns: {
      code: "巡检编号",
      responsible: "巡检负责人",
      date: "日期",
      conservationState: "保养状态",
      anomalies: "异常数量",
      status: "状态",
      origin: "来源",
      pdf: "巡检表",
    },
    pdfAvailableAfterFinalize: "定稿后可用",
    pdfUnavailable: "巡检表尚不可下载",
    pdfPreviewTitle: "巡检表",
    pdfVerificationCode: "验证码：",
  },
  status: {
    open: "待开始",
    inProgress: "进行中",
    finalized: "已定稿",
    notFinalized: "未定稿",
  },
  origin: {
    scheduled: "已计划",
    manual: "未计划",
  },
  filters: {
    code: "巡检编号",
    responsible: "巡检负责人",
    dateFrom: "起始",
    dateTo: "结束",
    status: "状态",
    origin: "来源",
    hasAnomalies: "有异常",
    all: "全部",
    allFeminine: "全部",
    yes: "是",
    no: "否",
    codePlaceholder: "例如：42",
    responsiblePlaceholder: "输入姓名…",
    dateRangeInvalid: "起始日期不能晚于结束日期",
  },
  form: {
    title: "巡检表",
    titleWithCode: "巡检表 #{{code}}",
    unsupportedVersion:
      "当前系统版本不支持该巡检表版本（{{version}}）。请刷新页面；若仍然出现，请联系支持人员。",
    stepsHeading: "表单步骤",
    stepOf: "第 {{current}} 步，共 {{total}} 步",
    saveAndContinue: "保存并继续",
    removeOccurrence: "移除",
    selectPlaceholder: "请选择…",
    stepLocked: "请先完成前面的步骤以解锁",
    stepIncomplete: "请填写该步骤的必填项后再保存并继续。未完成的字段已在下方标出。",
    fieldErrorAnswer: "请选择一个选项。",
    fieldErrorObservations: "请填写备注。",
    fieldErrorPhotos: "请至少上传一张照片。",
    fieldErrorValue: "请填写此字段。",
    readOnly: "只读",
    readOnlyWithStatus: "只读（{{status}}）",
    extrasHint: "额外参与人在尚未签名时可移除。",
    stepNotApplicable: "该步骤已标为不适用 — 项目已隐藏且不计入异常。",
    stepAppliesQuestion: "此阶段是否适用于该结构？",
    observationsPlaceholder: "描述观察到的状况…",
    observationsPlaceholderOptional: "备注（可选）…",
    anomalyReqNote: "该答案视为异常 — 必须填写备注并附照片。",
    anomalyReqNoteGrade: "“一般”和“不足”视为异常 — 必须填写备注并附照片。",
    collapseExpand: "展开",
    collapseMinimize: "收起",
    occurrenceEmpty: "选择“是”时至少需要 1 条记录。请添加。",
    occurrenceEmptyCrack: "选择“是”时至少需要 1 条记录。请添加裂缝。",
    occurrenceEmptySettlement: "选择“是”时至少需要 1 条记录。请添加沉降。",
    occurrenceEmptySeepage: "选择“是”时至少需要 1 条记录。请添加渗流。",
    occurrenceEmptyErosion: "选择“是”时至少需要 1 条记录。请添加侵蚀。",
    occurrenceEmptyChannel: "选择“是”时至少需要 1 条渠线。请至少添加一条渠线。",
    occurrenceEmptyGeomembrane: "评为一般/不足时至少需要 1 条土工膜记录。",
    collapseYesPending: "是 — 待填写",
    collapseRecordCount: "{{count}} 条记录",
    collapseLineCount: "{{count}} 条线",
    collapseCleanliness: "清洁",
    collapseStructure: "结构",
    pendingSummary: "待填写",
    optionalSummary: "选填",
    occurrencePendingTag: "待登记",
    entryLineTag: "第 {{n}} 行",
    drainageChannelDoubleAnomalyHint:
      "清洁评为“一般/不足”且结构评为“一般/不足”时，计为两项独立异常（本行 +2）。",
    anomalyTag: "异常",
    naCheckbox: "N/A（不适用）",
    entryAnomNote: "每条记录计为 1 项异常。",
    entryAnomNoteGeomembrane: "每次出现（G1、G2…）计为 1 项异常。",
    hintOptional: "可选 — 不计入异常，也不阻止定稿。",
    hintInformative: "仅供参考 — 不计入异常，也不要求照片。",
    hintInformativeNoNa: "仅供参考 — 不计入异常。无 N/A 选项。",
    extraSourceLegend: "添加方式",
    extraSourceName: "外部人员",
    extraSourceGs3User: "GS3 用户",
    extraSourceHelpAria: "GS3 用户与外部人员的区别",
    extraSourceHelpGs3: "GS3 用户：系统中已有账号，姓名来自登记信息。",
    extraSourceHelpExternal: "外部人员：没有 GS3 账号，请填写姓名。",
    extraDuplicate: "该参与者已在此次巡检中。",
    gs3User: "GS3 用户",
    gs3UserPlaceholder: "搜索用户…",
    gs3UserNotFound: "未找到用户",
    participantNamePlaceholder: "姓名",
    generalData: {
      code: "巡检编号",
      responsible: "巡检负责人",
      date: "巡检日期",
      dateScheduledSuffix: "（计划 — 不可更改）",
      extraParticipants: "额外参与人",
      addExtraParticipant: "添加",
      extraParticipantName: "姓名",
    },
    generalComments: {
      label: "总体备注",
      placeholder:
        "详述巡检中观察到的所有要点，包括结构上的维护、工程或干预…",
    },
  },
  photos: {
    remove: "移除",
    expand: "放大 {{name}}",
    preview: "照片 {{name}}",
    closePreview: "关闭照片",
    previous: "上一张",
    next: "下一张",
    counter: "{{current}} / {{total}}",
    save: "保存",
    deleteTitle: "移除照片",
    deleteCaption: "即将移除的照片：",
    deleteDescription: "照片将从表单中消失。如需可重新附加。",
    deleteConfirm: "移除",
    deleteCancel: "取消",
    acceptHint: "支持的格式：JPEG、PNG 或 WebP（被拒时：COD. 6.10.15）",
    tooLarge: "文件超过 10 MB",
  },
  participants: {
    title: "参与人",
    signLead: "参与人在“常规数据”中登记。本步骤进行字体签名。仅在此可定稿。",
    name: "姓名",
    add: "添加",
    addTitle: "添加参与人",
    remove: "移除",
    signed: "已签名",
    pending: "未签名",
    pendingSignature: "待签名",
    sign: "签名",
    resign: "重新签名",
    roleResponsible: "负责人",
    roleExtra: "额外",
    kindGs3: "GS3",
    kindExternal: "外部",
    finalizeHint: "所有参与人均签名后即可定稿。",
  },
  signature: {
    titleWithName: "签名 — {{name}}",
    fonts: {
      classic: "经典",
      elegant: "优雅",
      casual: "随意",
      bold: "粗体",
      modern: "现代",
      rounded: "圆润",
    },
    name: "签名姓名",
    font: "选择签名字体",
    preview: "实时预览",
    confirm: "确认签名",
    signedAt: "签名时间",
  },
  finalize: {
    title: "定稿巡检",
    subtitle: "请核对下方摘要。确认后表单将变为只读并生成 PDF。",
    warningBefore: "此操作",
    warningIrreversible: "无法撤销",
    warningAfter: "。定稿后表单数据不可再更改。",
    confirm: "确认并定稿",
    confirming: "正在定稿…",
    cancel: "取消",
    code: "编号",
    inspectionDate: "巡检日期",
    signatures: "签名",
    signaturesOf: "{{signed}} / {{total}}",
    anomalyCount: "异常数量",
    ecSum: "EC 合计",
  },
  delete: {
    title: "永久删除项目",
    caption: "待删除项目：",
    description: "此操作不可逆。删除后数据无法恢复。",
    confirm: "删除",
    cancel: "取消",
    item: "巡检 #{{code}} — {{date}}",
  },
  catalog: {
    v1: inspectionCatalogV1ZhCN,
  },
};
